import "./report.css";
import React, { useState, useEffect } from 'react';


export default function Report()
 {  

    const [reports, setReports]  = useState(null)
    useEffect( () => {   
         var requestOptions = {
        method: 'GET',
        redirect: 'manual',
        credentials: 'same-origin'
      };
          
        fetch("https://intranet-backend.procuratio.com/get_report.php", requestOptions)
      .then(response => response.text())
      .then(result => setReports([JSON.parse(result).data]))
      .catch(error => console.log('error', error));},[])

      useEffect( () => { console.log(reports)},[reports])

    return    (

    <><div id="wrapper">Report
    
    { reports != null ? <div style= {{ padding: '5px', margin: '10px', background: 'white', border: '1px solid darkgreen' }}>
    { reports[0].id } - { reports[0].reportName} : { reports[0].reportContent}

        </div> : '' }
        </div>

    </> 
    
    )

 }


